module.exports = __webpack_public_path__ + "img/checkApp5.a326cb17.png";